export let fields = { text: 'label', value: 'value' };

export let Type = [
    { label: 'Direct purchase tender', value: 1 },
    { label: 'Price Application', value: 2 },
    { label: 'Apply tender result', value: 3 },
    { label: 'Renew', value: 4 },
];

export let Status = [
    { label: "Open", value: 1 },
    { label: "Waiting", value: 2},
    { label: "Close", value: 3 },
    { label: "Lost", value: 4 },
];

export let Scope: string[] = [
    "Public",
    "Private",
    "None",
];

export let ProcurementStatus: string[] = [
    "Draft",
    "Send"
];

export let DirectOrIndirectTender: string[] = [
    "Direct",
    "Indirect"
];

export let TenderAllSearch = [
    { label: 'No Filter', value: 1 },
    { label: 'RefNo', value: 2 },
    { label: 'Customer Name', value: 3 },
    { label: 'Area', value: 4 },
    { label: 'Year', value: 5 },
    { label: 'Status', value: 6 },
    { label: 'Customer Code', value: 7 },
    { label: 'Detail Type', value: 8 },
    { label: 'Users', value: 9 },
];

export let TenderProcurementSearch = [
    { label: 'No Filter', value: 1 },
    { label: 'RefNo', value: 2 },
    { label: 'Customer Name', value: 3 },
    { label: 'Area', value: 4 },
    { label: 'Year', value: 5 },
    { label: 'Customer Code', value: 6 },
    { label: 'Detail Type', value: 7 },
];

export let TenderPreparationSearch = [
    { label: 'No Filter', value: 1 },
    { label: 'RefNo', value: 2 },
    { label: 'Customer Name', value: 3 },
    { label: 'Area', value: 4 },
    { label: 'Year', value: 5 },
    { label: 'Customer Code', value: 6 },
    { label: 'Detail Type', value: 7 },
];

export let TenderWaitingSearch = [
    { label: 'No Filter', value: 1 },
    { label: 'RefNo', value: 2 },
    { label: 'Customer Name', value: 3 },
    { label: 'Area', value: 4 },
    { label: 'Year', value: 5 },
    { label: 'Customer Code', value: 6 },
    { label: 'Detail Type', value: 7 },
    { label: 'Users', value: 8 }
];

export let TenderRecommendationSearch = [
    { label: 'No Filter', value: 1 },
    { label: 'RefNo', value: 2 },
    { label: 'Customer Name', value: 3 },
    { label: 'Area', value: 4 },
    { label: 'Year', value: 5 },
    { label: 'Customer Code', value: 6 },
    { label: 'Detail Type', value: 7 },
];

export let TenderLevels: string[] = [
    "Public",
    "Private",
    "None",
];

export let FinalApprovalOpts = [
    { label: 'Waiting for final recommendation', value: 1 },
    { label: 'Final recommendation', value: 2 },
    { label: 'Resend first recommendation', value: 3 }
];


export let ProductSearchOpts = [
    { label: 'None', value: 0 },
    { label: 'Product Name', value: 1 },
    { label: 'Product Code', value: 2 },
    { label: 'Principal Code', value: 3 }
];

export let ProductStatus = [
    { Name: 'All', Value: '1' },
    { Name: 'Active', Value: '2' },
    { Name: 'Inactive', Value: '3' }
];

export let ItemMasterSearch = [
    { label: 'No Filter', value: 0 },
    { label: 'Principal', value: 1 },
    { label: 'Item Code', value: 2 },
    { label: 'Product Name', value: 3 },
    { label: 'Active Element', value: 4 },
];

export let TechMasterSearch = [
    { label: 'No Filter', value: 0 },
    { label: 'Principal', value: 1 },
    { label: 'Product Code', value: 2 },
    { label: 'Product Name', value: 3 },
];

export let NameValueFields: Object = { text: 'Name', value: 'Value' };
